import { Typography } from 'antd';
import React from 'react';
import {
  FormConfigProps,
  FormStempContentProps,
  contentStyling,
} from '../../constants/constants';
import { DynamicFormField } from '../DynamicFormField';

export const requirementsPersonalizationConfig: Record<
  string,
  FormConfigProps
> = {
  noPublicSpeaking: {
    label: 'nereikalaujama atsakinėti prieš klasę',
    value: 'noPublicSpeaking',
  },
  useSelfMadePlanForAnswers: {
    label: 'leidžiama atsakinėti naudojantis paties mokinio sudarytu planu',
    value: 'useSelfMadePlanForAnswers',
  },
  usePreparedPlanForAnswers: {
    label: 'leidžiama atsakinėti naudojantis mokytojo sudarytu planu',
    value: 'usePreparedPlanForAnswers',
  },
  useKeywordPromptsForAnswers: {
    label: 'leidžiama atsakinėti remiantis atraminiais žodžiais',
    value: 'useKeywordPromptsForAnswers',
  },
  notRequiredReadAloud: {
    label: 'nereikalaujama skaityti garsiai',
    value: 'notRequiredReadAloud',
  },
  noNeatHandwriting: {
    label: 'nereikalaujama dailaus rašto',
    value: 'noNeatHandwriting',
  },
  writeBlockLetters: {
    label: 'leidžiama rašyti spausdintinėmis raidėmis',
    value: 'writeBlockLetters',
  },
  noMemorizeByHeart: {
    label: 'nereikalaujama išmokti mintinai',
    value: 'noMemorizeByHeart',
  },
  memorizePartText: {
    label: 'mintinai mokomasi numatyto teksto dalis',
    value: 'memorizePartText',
  },
  lessTheoreticalMaterialToMemorize: {
    label: 'mažinamas teorinės medžiagos įsiminimo kiekis',
    value: 'lessTheoreticalMaterialToMemorize',
    children: {
      lessTheoreticalMaterialToMemorize75: {
        label: '75%',
        value: 'lessTheoreticalMaterialToMemorize75',
        paddingLeft: 24,
      },
      lessTheoreticalMaterialToMemorize50: {
        label: '50%',
        value: 'lessTheoreticalMaterialToMemorize50',
        paddingLeft: 24,
      },
      lessTheoreticalMaterialToMemorize25: {
        label: '25%',
        value: 'lessTheoreticalMaterialToMemorize25',
        paddingLeft: 24,
      },
    },
  },
  lessCopyingTasks: {
    label: 'mažinamas nurašymo užduočių kiekis',
    value: 'lessCopyingTasks',
    children: {
      lessCopyingTasks75: {
        label: '75%',
        value: 'lessCopyingTasks75',
        paddingLeft: 24,
      },
      lessCopyingTasks50: {
        label: '50%',
        value: 'lessCopyingTasks50',
        paddingLeft: 24,
      },
      lessCopyingTasks25: {
        label: '25%',
        value: 'lessCopyingTasks25',
        paddingLeft: 24,
      },
    },
  },
  lessTechnicalDrawing: {
    label: 'mažinamas braižymo užduočių kiekis',
    value: 'lessTechnicalDrawing',
    children: {
      lessTechnicalDrawing75: {
        label: '75%',
        value: 'lessTechnicalDrawing75',
        paddingLeft: 24,
      },
      lessTechnicalDrawing50: {
        label: '50%',
        value: 'lessTechnicalDrawing50',
        paddingLeft: 24,
      },
      lessTechnicalDrawing25: {
        label: '25%',
        value: 'lessTechnicalDrawing25',
        paddingLeft: 24,
      },
    },
  },
  reducedWritingScope: {
    label: 'mažinamos rašto darbų apimtys',
    value: 'reducedWritingScope',
    children: {
      reducedWritingScope75: {
        label: '75%',
        value: 'reducedWritingScope75',
        paddingLeft: 24,
      },
      reducedWritingScope50: {
        label: '50%',
        value: 'reducedWritingScope50',
        paddingLeft: 24,
      },
      reducedWritingScope25: {
        label: '25%',
        value: 'reducedWritingScope25',
        paddingLeft: 24,
      },
    },
  },
  reducedTaskAmount: {
    label: 'mažinamas užduočių kiekis',
    value: 'reducedTaskAmount',
    children: {
      reducedTaskAmount75: {
        label: '75%',
        value: 'reducedTaskAmount75',
        paddingLeft: 24,
      },
      reducedTaskAmount50: {
        label: '50%',
        value: 'reducedTaskAmount50',
        paddingLeft: 24,
      },
      reducedTaskAmount25: {
        label: '25%',
        value: 'reducedTaskAmount25',
        paddingLeft: 24,
      },
    },
  },
  tasksReplacedWithAlts: {
    label: 'įprastos užduotys keičiamos alternatyviomis',
    value: 'tasksReplacedWithAlts',
  },
  allowSupportingMaterial: {
    label: 'praktinių veiklų metu leidžiama naudotis atramine medžiaga',
    value: 'allowSupportingMaterial',
  },
  useComputerForSomeWriting: {
    label: 'dalį rašto darbų leidžiama atlikti kompiuteriu',
    value: 'useComputerForSomeWriting',
    children: {
      useComputerForSomeWriting75: {
        label: '75%',
        value: 'useComputerForSomeWriting75',
        paddingLeft: 24,
      },
      useComputerForSomeWriting50: {
        label: '50%',
        value: 'useComputerForSomeWriting50',
        paddingLeft: 24,
      },
      useComputerForSomeWriting25: {
        label: '25%',
        value: 'useComputerForSomeWriting25',
        paddingLeft: 24,
      },
    },
  },
  useKeywordPromptsOnWritingTasks: {
    label: 'rašant leidžiama naudotis atraminiais žodžiais',
    value: 'useKeywordPromptsOnWritingTasks',
  },
  extendedTasksTime: {
    label: 'pratęsiamas užduočių atlikimo laikas',
    value: 'extendedTasksTime',
  },
  breaksForFocus: {
    label:
      'leidžiama turėti aktyvias ir (ar) sensorines pertraukas veiklos metu',
    value: 'breaksForFocus',
  },
  requirementsPersonalizationOther: {
    label: 'kita:',
    value: 'requirementsPersonalizationOther',
    isInput: true,
  },
};

export const Block32 = React.memo(
  ({ form, currentStep }: FormStempContentProps) => {
    return (
      <div
        style={{
          ...contentStyling,
          display: currentStep === 4 ? 'block' : 'none',
        }}
      >
        <Typography.Title
          style={{ marginTop: 0, marginBottom: 34, fontWeight: 'normal' }}
          level={4}
        >
          Reikalavimų personalizavimas:
        </Typography.Title>
        <DynamicFormField
          formItemConfig={requirementsPersonalizationConfig}
          formPathParams={['subject', 'block3', 'requirementsPersonalization']}
          form={form}
        />
      </div>
    );
  },
);
